export function Input({ type, onKeyDown, onWheel, ...props }) {
  const handleKeyDown = (e) => {
    if (type === 'number' && (e.key === 'ArrowUp' || e.key === 'ArrowDown')) {
      e.preventDefault()
    }
    if (onKeyDown) {
      onKeyDown(e)
    }
  }

  const handleWheel = (e) => {
    if (type === 'number') {
      e.target.blur()
    }
    if (onWheel) {
      onWheel(e)
    }
  }

  return <input type={type} onKeyDown={handleKeyDown} onWheel={handleWheel} {...props} />
}
